module.exports = __webpack_public_path__ + "img/T5-A-xh_10.83b37fc8.png";